import { useQuery } from "@tanstack/react-query";
import { entityService } from "../services/entityService";

const useEntity = () => {
    return useQuery({ queryKey: ['entity'], queryFn: () => entityService.getEntity() });
}

export default useEntity;